import { render, staticRenderFns } from "./SwatchesView.vue?vue&type=template&id=2c92d4ba"
import script from "./SwatchesView.vue?vue&type=script&lang=js"
export * from "./SwatchesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports